module.exports = __webpack_public_path__ + "media/lane_wise.95934624.webm";